// extracted by mini-css-extract-plugin
export default {"label":"CalendarLabel_label__xFrr7","tag":"CalendarLabel_tag__X0qw9"};